// 封装axios
import axios from 'axios'
import Qs from 'qs'
// import notification from 'ant-design-vue/lib/notification'

// 创建 axios 实例
const service = axios.create({
  headers: {
    'gray-version': '2.5.0-beta' // 全局灰度版本
  },
  baseURL: '/api-gateway', // api base_url
  timeout: 60000, // 请求超时时间 60s
  ignoreError: false, // 忽略200服务器返回失败，不提示
  transformRequest: [
    (data, headers) => {
      if (headers['Content-Type']) {
        if (headers['Content-Type'] === 'multipart/form-data') {
          return data
        }
        if (headers['Content-Type'].includes('application/json')) {
          return JSON.stringify(data)
        }
      }
      // 对 data 进行任意转换处理
      return Qs.stringify(data, { indices: false })
    }
  ],
  transformResponse: [
    (data) => {
      let reponseVal = data
      const hasSecureJsonPrefix = data.startsWith('while') // 返回值添加了防JSON劫持代码
      if (data.startsWith('{') || data.startsWith('[') || hasSecureJsonPrefix) {
        // 返回值为json
        reponseVal = JSON.parse(hasSecureJsonPrefix ? data.substr(9) : data)
      }
      return reponseVal
    }
  ]
})

function errorLog(error) {
  console.log(error)
  // notification.error({
  //   message: '错误',
  //   description: error || '服务器内部错误，请重新尝试'
  // })
}

const err = (error) => {
  if (axios.isCancel(error)) {
    return new Promise(() => {})
  }

  if (error.response) {
    if (error.response.status === 500) {
      this.$message.error({
        message: '服务器内部错误，请重新尝试',
        center: true
      })
    } else {
      console.log(error)
    }
  }
  return Promise.reject(error)
}

service.interceptors.request.use(
  (config) => {
    return config
  },
  (error) => Promise.reject(error)
)

// 响应拦截器
service.interceptors.response.use((response) => {
  const responseData = response.data
  if (responseData) {
    responseData.headers = response.headers
    const { success, message } = responseData
    if (!success && !response.config.ignoreError) {
      errorLog(message)
    }
    return responseData
  }
}, err)

export { service, service as axios }
